module.exports = __webpack_public_path__ + "static/media/18.27f61d9a.jpg";